export const Initiatives = {
  QUICKLINKS_CONNECTED: {
    id: "QuickLinksConnected",
    name: "GoodLinks Connected Org (default)",    
    integrator: "GoodLink",
    integratorId: "",
    channel: "GoodLink",
    connectedOrg: true,
    referenceId: "QuickLink",
    description: "GoodLinks Connected Org will use GoodLink as the integrator and no API keys are needed.",
  },
  // QUICKLINKS: {
  //   id: "QuickLinksAPIKeys",
  //   name: "QuickLinks API keys",
  //   integrator: "",
  //   integratorId: "",
  //   connectedOrg: false,    
  //   channel: "GoodLink",
  //   description: "QuickLinks API keys will use the API keys to create a QuickLink.",
  // },
  GOODLEAPPLUS_ROOFHUB: {
    id: "GoodLeapPlusRoofHub",
    name: "GoodLeapPlus RoofHub",
    integrator: "SRSIntegrator",
    integratorId: "03d5a28f-5e24-4d89-93de-fd03d70fd4f7",
    connectedOrg: true,
    channel: "roofhub",
    description: "GoodLeapPlus RoofHub will use SRSIntegrator as the integrator and no API keys are needed.",
    referenceId: "GoodLeapPlus",
  },
  INTEGRATOR_OTHER: {
    id: "GoodLeapPlusOther",
    name: "GoodLeapPlus Other",
    integrator: "[Replace with integrator name]",
    integratorId: "[Replace with integrator id]",
    connectedOrg: true,
    description: "GoodLeapPlus [Other] will use and Integrator via connected  and id to create a GoodLeapPlus QuickLink.",
    channel: "GoodLeapPlus",
    referenceId: "GoodLeapPlus",
  },
};

/** Stable order for selects and help text. */
export const INITIATIVE_OPTIONS = [
  Initiatives.QUICKLINKS_CONNECTED,
  // Initiatives.QUICKLINKS,
  Initiatives.GOODLEAPPLUS_ROOFHUB,
  Initiatives.INTEGRATOR_OTHER,
];

export function getInitiativeById(id) {
  if (!id) return null;
  return INITIATIVE_OPTIONS.find((i) => i.id === id) || null;
}

/**
 * Maps initiative.integrator for parentOrganizationClientId when it is a real value;
 * otherwise uses integratorId when it looks like a real id (not a placeholder).
 */
export function parentOrganizationClientIdFromInitiative(ini) {
  if (!ini) return "";
  const integ = String(ini.integrator || "").trim();
  if (
    integ &&
    !integ.startsWith("[") &&
    !integ.toLowerCase().includes("replace")
  ) {
    return integ;
  }
  const integId = String(ini.integratorId || "").trim();
  if (
    integId &&
    !integId.startsWith("[") &&
    !integId.toLowerCase().includes("replace")
  ) {
    return integId;
  }
  return "";
}

/** UUID / real integrator id from initiative; omits placeholders. GoodLink initiatives omit integratorId. */
export function integratorIdFromInitiative(ini) {
  if (!ini) return "";
  if (ini.id === Initiatives.QUICKLINKS_CONNECTED.id) return "";
  const id = String(ini.integratorId || "").trim();
  if (!id) return "";
  if (id.startsWith("[")) return "";
  if (id.toLowerCase().includes("replace")) return "";
  return id;
}

/** Stored on SharedApp / request as `referenceId` (e.g. QuickLink, GoodLeapPlus). */
export function referenceIdFromInitiative(ini) {
  if (!ini) return "";
  return String(ini.referenceId || "").trim();
}

export function isRoofHubInitiative(initiativeId) {
  return initiativeId === Initiatives.GOODLEAPPLUS_ROOFHUB.id;
}

/** Defaults when creating a request from a selected initiative (public request form). */
export function requestCreateDefaultsFromInitiative(ini) {
  const referenceId = referenceIdFromInitiative(ini);
  if (isRoofHubInitiative(ini?.id)) {
    return {
      referenceId: referenceId || "GoodLeapPlus",
      sendEmail: false,
    };
  }
  return {
    referenceId,
    sendEmail: true,
  };
}

/**
 * Resolve initiative from a saved request `referenceId` (reference value or legacy initiative id).
 */
export function getInitiativeForRequestReference(referenceId) {
  if (!referenceId) return null;
  const ref = String(referenceId).trim();
  const byId = getInitiativeById(ref);
  if (byId) return byId;
  const lower = ref.toLowerCase();
  return (
    INITIATIVE_OPTIONS.find(
      (i) => String(i.referenceId || "").trim().toLowerCase() === lower
    ) || null
  );
}